import { Dropdown } from 'bootstrap';

window.Dropdown = Dropdown;
